import React from "react";

export const PageHeader = ({ icon: Icon, title, subtitle, right }) => (
  <div className="relative overflow-hidden bg-navy">
    <div className="pointer-events-none absolute -right-16 -top-16 h-72 w-72 rounded-full bg-brandblue/30 blur-3xl" />
    <div className="relative mx-auto flex max-w-5xl flex-wrap items-center justify-between gap-4 px-4 py-10 sm:px-6">
      <div className="flex items-center gap-4">
        {Icon && (
          <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-white/10 text-white ring-1 ring-white/15">
            <Icon size={22} />
          </span>
        )}
        <div>
          <h1 className="font-display text-2xl font-extrabold text-white sm:text-3xl">{title}</h1>
          {subtitle && <p className="mt-1 text-sm text-white/70">{subtitle}</p>}
        </div>
      </div>
      {right}
    </div>
  </div>
);
